export const APP_BRAND_NAME =
  (import.meta.env.VITE_APP_BRAND_NAME as string | undefined) || "Apex";
